module.exports = __webpack_public_path__ + "static/media/loginBg.982de8fe.jpg";